<template>
	<div class="layout-menu-container">
		<AppSubmenu :total_badge_all_visit="total_badge_all_visit" :total_badge_visit="total_badge_visit" :total_badge_purchase_request="total_badge_purchase_request" :total_badge_rental_order_key="total_badge_rental_order" :items="model" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" :key="menuKey"/>
	</div>
</template>

<script>
import AppSubmenu from './Submenu';

export default {
	props: {
		model: Array
	},
	data() {
		return {
			menuKey: 0,
			total_badge_rental_order: 0,
			total_badge_visit: 0,
			total_badge_purchase_request: 0 ,
			total_badge_all_visit: 0
		}
	},
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
		async fetchBadgeCount() {
		// Gọi API để lấy badge count
		//console.log('Gọi API badge count...');
		
		setTimeout(async () => {
		var dataBadge = await this.$CoreService.get_badge_order();
		this.total_badge_rental_order = dataBadge.total;
		this.total_badge_visit = await this.$CoreService.get_badge_visit();
		this.total_badge_purchase_request = await this.$CoreService.get_badge_purchase_request();
		this.total_badge_all_visit = parseInt(this.total_badge_visit) + parseInt(this.total_badge_purchase_request);

		//this.menuKey++;
		}, 1000);
    }
    },
	components: {
		'AppSubmenu': AppSubmenu
	},
	watch: {
		$route() {
			setTimeout(() => {
				if (this.$router.currentRoute.path == "/admin/403") {
					this.menuKey++;
				}
			}, 100)
		},
	},
	async mounted() {
		this.fetchBadgeCount();

	// 	setInterval(() => {
    //   		//this.fetchBadgeCount();
    // }, 10000);
	setInterval(() => {
      this.fetchBadgeCount();
    }, 20000);
	},
	
}
</script>

<style scoped>

</style>